import { Flame } from "lucide-react";
import { weatherSvg } from "@/lib/weatherIcon";

const riskClass = (r) =>
  r === "TINGGI" ? "risk-high" : r === "WASPADA" ? "risk-watch" : "risk-safe";

export default function DistrictList({ districts, selected, onSelect, onReset, totalHotspots }) {
  return (
    <aside className="district-panel" data-testid="district-summary">
      <div className="panel-heading">
        <div>
          <span className="section-kicker">RINGKASAN WILAYAH</span>
          <h3>Titik hotspot per kecamatan</h3>
        </div>
        <span className="count" data-testid="district-total-hotspots">
          {totalHotspots} titik
        </span>
      </div>
      <div className="district-grid">
        {districts.map((d) => (
          <button
            className={`district-card ${selected === d.name ? "active" : ""}`}
            key={d.name}
            data-testid={`district-${d.name.toLowerCase().replaceAll(" ", "-")}`}
            onClick={() => onSelect(d.name)}
          >
            <div className="dc-head">
              <i className={`status-dot ${riskClass(d.overall_risk)}`} />
              <span>{d.name}</span>
            </div>
            <div className="dc-fire">
              <Flame size={14} />
              <b data-testid={`district-hotspot-${d.name.toLowerCase().replaceAll(" ", "-")}`}>
                {d.hotspot_count}
              </b>
              <em>titik api</em>
            </div>
            <div className="dc-foot">
              <span>{d.rainfall != null ? `${d.rainfall} mm` : d.weather}</span>
              <b className={riskClass(d.overall_risk)}>{d.overall_risk}</b>
            </div>
            {d.forecast?.length > 0 && (
              <div
                className="dc-forecast"
                data-testid={`district-forecast-${d.name.toLowerCase().replaceAll(" ", "-")}`}
              >
                {d.forecast.map((f) => (
                  <div
                    className="dcf-day"
                    key={f.date}
                    title={`${f.label}: ${f.weather} · hujan ${f.rain} mm · ${f.tmin ?? "—"}–${f.tmax ?? "—"}°C`}
                  >
                    <span>{f.label}</span>
                    <i dangerouslySetInnerHTML={{ __html: weatherSvg(f.weather, 14) }} />
                    <b>{f.tmax != null ? `${f.tmax}°` : "—"}</b>
                    <em>{f.rain > 0 ? `${f.rain} mm` : "0 mm"}</em>
                  </div>
                ))}
              </div>
            )}
          </button>
        ))}
      </div>
      <button
        className="all-districts"
        data-testid="reset-district-filter"
        onClick={onReset}
      >
        Lihat semua wilayah <span>→</span>
      </button>
    </aside>
  );
}
